/**
 * LLM Provider Icons
 * 멀티 프로바이더 브랜드 아이콘
 */
import React from 'react';

// ============================================
// Provider Icons
// ============================================

// Claude (Anthropic)
export const ClaudeIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#D97706"/>
    <path d="M15.5 16h-1.5l-.9-2.5H10.9L10 16H8.5l3.1-8h1.8l3.1 8zm-3.5-6.5l-1.1 3h2.2l-1.1-3z" fill="white"/>
  </svg>
);

// OpenAI GPT
export const OpenAIIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#10B981"/>
    <path d="M12 6v12M6 12h12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="1.5" fill="none"/>
  </svg>
);

// Google Gemini
export const GeminiIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#4285F4"/>
    <path d="M12 6l1.5 3.5L17 11l-3.5 1.5L12 16l-1.5-3.5L7 11l3.5-1.5L12 6z" fill="white"/>
    <circle cx="16" cy="8" r="1.5" fill="#EA4335"/>
    <circle cx="8" cy="16" r="1.5" fill="#FBBC05"/>
  </svg>
);

// Perplexity
export const PerplexityIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#8B5CF6"/>
    <circle cx="10" cy="10" r="4" stroke="white" strokeWidth="2" fill="none"/>
    <path d="M13 13l4 4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Amazon Nova
export const AmazonIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#FF9900"/>
    <path d="M7 14c0 0 2.5 2 5 2s5-2 5-2" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 12l1.5 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 9l1.5 1.5L11 9M13 9l1.5 1.5L16 9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ============================================
// Model-specific Icons
// ============================================

// Opus (Crown)
export const OpusIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#7C3AED"/>
    <path d="M6 14l2-6 4 3 4-3 2 6H6z" fill="white"/>
    <circle cx="8" cy="8" r="1" fill="#FFD700"/>
    <circle cx="12" cy="7" r="1" fill="#FFD700"/>
    <circle cx="16" cy="8" r="1" fill="#FFD700"/>
  </svg>
);

// Haiku (Lightning)
export const HaikuIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#F59E0B"/>
    <path d="M13 7l-4 6h3l-1 4 4-6h-3l1-4z" fill="white"/>
  </svg>
);

// Sonnet (Quill)
export const SonnetIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#D97706"/>
    <path d="M15 7l-6 10M9 7l3 5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="9" cy="7" r="1.5" fill="white"/>
  </svg>
);

// Nova (Star)
export const NovaIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#2563EB"/>
    <path d="M12 6l1.5 3.5L17 11l-3.5 1.5L12 16l-1.5-3.5L7 11l3.5-1.5L12 6z" fill="white"/>
  </svg>
);

// Nova Lite
export const NovaLiteIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#0EA5E9"/>
    <path d="M12 7l1 2.5L15.5 11l-2.5 1L12 14.5l-1-2.5L8.5 11l2.5-1L12 7z" fill="white"/>
    <circle cx="16" cy="8" r="1" fill="white" opacity="0.6"/>
  </svg>
);

// GPT-4o
export const GPT4oIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#10B981"/>
    <path d="M8 12a4 4 0 108 0 4 4 0 00-8 0z" stroke="white" strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="1.5" fill="white"/>
  </svg>
);

// GPT-4o Mini
export const GPT4oMiniIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#34D399"/>
    <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="1" fill="white"/>
  </svg>
);

// Gemini Flash
export const GeminiFlashIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#3B82F6"/>
    <path d="M13 7l-4 5h3l-1 5 4-6h-3l1-4z" fill="white"/>
  </svg>
);

// Gemini Pro
export const GeminiProIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#6366F1"/>
    <path d="M12 6l2 4 4 1-3 3 1 4-4-2-4 2 1-4-3-3 4-1 2-4z" fill="white"/>
  </svg>
);

// Perplexity Pro
export const PerplexityProIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#8B5CF6"/>
    <circle cx="10" cy="10" r="3.5" stroke="white" strokeWidth="2" fill="none"/>
    <path d="M13 13l4 4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 7l2 2M15 7l-2 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"/>
  </svg>
);

// Perplexity Sonar
export const PerplexitySonarIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#A78BFA"/>
    <circle cx="10" cy="10" r="3" stroke="white" strokeWidth="1.5" fill="none"/>
    <path d="M12.5 12.5l3.5 3.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// ============================================
// Icon Maps
// ============================================

// Provider icons (fallback)
export const MODEL_ICONS = {
  'anthropic': ClaudeIcon,
  'openai': OpenAIIcon,
  'google': GeminiIcon,
  'perplexity': PerplexityIcon,
  'amazon': AmazonIcon,
};

// Model-specific icons
export const MODEL_SPECIFIC_ICONS = {
  // Claude
  'claude-sonnet-4-6': SonnetIcon,
  'claude-haiku-4-5': HaikuIcon,
  'claude-opus-4-6': OpusIcon,
  // OpenAI
  'gpt-4o': GPT4oIcon,
  'gpt-4o-mini': GPT4oMiniIcon,
  // Google
  'gemini-2-flash': GeminiFlashIcon,
  'gemini-1-5-pro': GeminiProIcon,
  // Perplexity
  'perplexity-sonar-pro': PerplexityProIcon,
  'perplexity-sonar': PerplexitySonarIcon,
  // Amazon
  'nova-pro': NovaIcon,
  'nova-lite': NovaLiteIcon,
};

// Generic Model Icon component
export const ModelIcon = ({ providerId, modelId, className = "w-4 h-4" }) => {
  // Try model-specific icon first
  if (modelId && MODEL_SPECIFIC_ICONS[modelId]) {
    const SpecificIcon = MODEL_SPECIFIC_ICONS[modelId];
    return <SpecificIcon className={className} />;
  }

  // Fall back to provider icon
  const IconComponent = MODEL_ICONS[providerId];
  if (!IconComponent) return null;
  return <IconComponent className={className} />;
};

export default ModelIcon;
